var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Header',{on:{"getLogoInfo":_vm.getLogoInfo,"changeDrawer":_vm.changeDrawer}}),_c('Menu',{ref:"menuRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }